var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{attrs:{"for":_vm.fileid}},[(_vm.useNativeUpload)?_c('div',{on:{"click":_vm.uploadWithKNB}}):_vm._e(),(!_vm.useNativeUpload)?_c('input',{ref:"uploader",attrs:{"id":_vm.fileid,"type":"file","accept":"image/*"},on:{"change":_vm.preview}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }